import React from 'react';
import * as S from './styled';
import { Colors } from '../../colors';
export const PulsingDot = ({ color = Colors.G300, label }) => (React.createElement(S.Container, { color: color },
    React.createElement(S.Dot, null),
    label && React.createElement(S.Label, null, label)));
